// (function (Drupal) { // UNCOMMENT IF DRUPAL.
//
//   Drupal.behaviors.mainMenu = {
//     attach: function (context) {

(function () { // REMOVE IF DRUPAL.

  const $navList = document.querySelector('.priority-plus__list');
  const $shadowStart = document.querySelector('.priority-plus__shadow--start');
  const $shadowEnd = document.querySelector('.priority-plus__shadow--end');

  function handleShadowVisibility() {
    const maxScrollStartReached = $navList.scrollLeft <= 0;
    const maxScrollEndReached = $navList.scrollLeft >= $navList.scrollWidth - $navList.offsetWidth;

    toggleShadow($shadowStart, maxScrollStartReached);
    toggleShadow($shadowEnd, maxScrollEndReached);
  }

  function toggleShadow($el, maxScrollReached) {
    const shadowIsVisible = $el.classList.contains('is-visible');
    const showShadow = !maxScrollReached && !shadowIsVisible;
    const hideShadow = maxScrollReached && shadowIsVisible;

    // Using requestAnimationFrame for optimal scroll performance.
    // https://stackoverflow.com/a/44779316
    if (showShadow) {
      window.requestAnimationFrame(() => $el.classList.add('is-visible'));
    } else if (hideShadow) {
      window.requestAnimationFrame(() => $el.classList.remove('is-visible'));
    }
  }

  handleShadowVisibility();
  $navList.addEventListener('scroll', (e) => handleShadowVisibility(e));

})(); // REMOVE IF DRUPAL.

// })(Drupal); // UNCOMMENT IF DRUPAL.
